import { render } from "./VipSetting.vue?vue&type=template&id=808c0f8e"
import script from "./VipSetting.vue?vue&type=script&lang=js"
export * from "./VipSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__